import React from "react";
import EdButton, { EdLinkButton, EdALinkButton } from "./edButton";
import DeviceContext from "../service/indentifyDevice";

if (DeviceContext().isMobile) {
	require("../../assets/scss/components/generic/noDataCont/noDataContainerMob.scss");
} else {
	require("../../assets/scss/components/generic/noDataCont/noDataContainer.scss");
}

export interface INoDataContainerProps {
	txtHeading: string;
	txtSubHeading?: string;
	linkDet?: { txt: string; type: "btn"; clickHandler: (value: any) => void } | { txt: string; href: string; type: "aLink" };
	btnDet?: { txt: string; type: "btn"; clickHandler: (value: any) => void } | { txt: string; href: string; type: "bLink" | "aLink" };
}

const NoDataContainer: React.FC<INoDataContainerProps> = (props: INoDataContainerProps) => {
	return (
		<div className="no_data_cont">
			<div className="icon"></div>
			<h2 className="err_msg">{props.txtHeading}</h2>
			<h3 className="err_msg_sub">{props.txtSubHeading}</h3>
			{/* hide button if no text is passed*/}
			{props.btnDet && (
				<div>
					{props.btnDet.type === "btn" && (
						<EdButton value={props.btnDet.txt} btnTyp="primary" onClick={props.btnDet.clickHandler} className="place_order_btn" />
					)}
					{props.btnDet.type === "bLink" && (
						<EdLinkButton LinkHref={props.btnDet.href} value={props.btnDet.txt} btnTyp="primary" className="place_order_btn" />
					)}
					{props.btnDet.type === "aLink" && (
						<EdALinkButton LinkHref={props.btnDet.href} value={props.btnDet.txt} btnTyp="primary" className="place_order_btn" />
					)}
				</div>
			)}
			{props.linkDet && (
				<div>
					{props.linkDet.type === "btn" && (
						<EdButton value={props.linkDet.txt} btnTyp="blue-link" onClick={props.linkDet.clickHandler} className="clr_fltr" />
					)}
					{props.linkDet.type === "aLink" && (
						<a href={props.linkDet.href} className="ed_button blue-link clr_fltr button">
							{props.linkDet.txt}
						</a>
					)}
				</div>
			)}
		</div>
	);
};

export default NoDataContainer;
